import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { PermissionSetType, UserType } from 'api/models';
import { toastService } from 'components/molecules/toast';
import { addMembersToProject } from 'data/projects/actions';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';

export const useJoinProject = (projectId: number) => {
  const dispatch = useDispatch();
  const { user } = useUser();
  const [isLoading, setIsLoading] = useState(false);

  const translatedTexts = {
    success: {
      title: useTranslation('invitation.self.project_joined.success.title'),
      message: useTranslation('invitation.self.project_joined.success.content'),
    },
    error: {
      title: useTranslation('invitation.self.project_joined.error.title'),
      message: useTranslation('invitation.self.project_joined.error.content'),
    },
  };

  const handleSuccess = () => {
    toastService({
      toastContainer: {},
      title: translatedTexts.success.title,
      message: translatedTexts.success.message,
    }).success();
    setIsLoading(false);
  };

  const handleFailure = () => {
    toastService({
      toastContainer: {},
      title: translatedTexts.error.title,
      message: translatedTexts.error.message,
    }).error();

    setIsLoading(false);
  };

  const handleProjectJoin = () => {
    if (
      (user.userType === UserType.Native ||
        user.userType === UserType.Partner) &&
      projectId
    ) {
      const payload = {
        user: { userId: user.userId },
        permissionSet: {
          permissionSetType:
            user.userType === UserType.Native
              ? PermissionSetType.Collaborator
              : PermissionSetType.PartnerCollaborator,
        },
      };

      setIsLoading(true);
      dispatch(
        addMembersToProject({
          projectId,
          members: [payload],
          handleSuccess,
          handleFailure,
        }),
      );

      return true;
    }

    return false;
  };

  return { isLoading, handleProjectJoin };
};
